import React from "react";
import {Route} from "react-router-dom";

import RequireAuthentication from "hoc/authentication/requireAuthentication";
import {sessionStore} from "../../utils/sessionStore";

import Printers from "views/picking/printers";

let routes = [];
const applications = sessionStore.get("applications");

if (applications && applications["picking"]) {
    routes.push([
        <Route
            path="/picking/printers"
            component={RequireAuthentication(Printers)}
            exact
            key="printers"
        />,
    ])
}

export default routes;
